// =============================================================================
// Store: módulo activo (hallazgo A2 resuelto)
// -----------------------------------------------------------------------------
// Estado global por aplicación (singleton con refs a nivel de módulo, estilo
// Pinia). Reemplaza el `ref('core')` que vivía dentro de useAppModules.
// =============================================================================
import { ref } from 'vue';
import { appModules } from '@/config/modulesConfig';

const activeModuleId = ref('core');

export function useModuleStore() {
  const switchModule = (moduleId) => {
    if (appModules[moduleId]) activeModuleId.value = moduleId;
  };

  return { activeModuleId, switchModule };
}